import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Field                from '../../Field';

class ResidentialReferenceRequest extends Component {
    constructor(props) {
        super(props);
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUpdate() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    getChildInputComponents() {
        let inputComponents = [];
        inputComponents = inputComponents.concat(this.inputComponents);
        this.childComponents.filter(component => {
            return (component !== null) && (component !== undefined);
        }).map(component => {
            inputComponents = inputComponents.concat(component.getChildInputComponents());
        });

        return inputComponents;
    }

    render() {
        return (
            <div>
                <Field
                    fieldName={'applicantStayDuration'}
                    question={'How long have they been a tenant in your property?'}
                    storageKey={'applicantStayDuration'}
                    type={'date'}
                    subType={'year-month'}
                    limitMonths={true}
                    source={this.props.source}
                    dataValidation={'duration_months_tenancy.non_mandatory'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName={'monthlyRent'}
                    type={'money'}
                    question={'What is their current monthly rent?'}
                    storageKey={'monthlyRent'}
                    source={this.props.source}
                    dataValidation={'2_decimal_money.non_mandatory'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName={'hasRentPaidPromptly'}
                    type={'button-choice'}
                    question={'Has the rent always been paid promptly?'}
                    storageKey={'hasRentPaidPromptly'}
                    source={this.props.source}
                    options={[
                        {
                            value: true,
                            text: 'Yes'
                        },
                        {
                            value: false,
                            text: 'No'
                        }
                    ]}
                    dataValidation={'required_field'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName={'isSatisfied'}
                    type={'button-choice'}
                    question={'Has the tenancy been conducted in a satisfactory manner?'}
                    storageKey={'isSatisfied'}
                    source={this.props.source}
                    options={[
                        {
                            value: true,
                            text: 'Yes'
                        },
                        {
                            value: false,
                            text: 'No'
                        }
                    ]}
                    dataValidation={'required_field'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName={'isGoodTenant'}
                    type={'button-choice'}
                    question={'Do you consider the applicant to be a good tenant?'}
                    storageKey={'isGoodTenant'}
                    source={this.props.source}
                    options={[
                        {
                            value: true,
                            text: 'Yes'
                        },
                        {
                            value: false,
                            text: 'No'
                        }
                    ]}
                    dataValidation={'required_field'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName={'refereeName'}
                    type={'text'}
                    question={'Your name/position'}
                    storageKey={'refereeName'}
                    source={this.props.source}
                    maxLength={60}
                    dataValidation={'alpha_and_space_only'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
            </div>
        );
    }
}

ResidentialReferenceRequest.propTypes = {
    source: PropTypes.string.isRequired,
};

export default ResidentialReferenceRequest;


// WEBPACK FOOTER //
// ./src/components/Screens/ReferenceRequest/Residential.js